import { useEffect, useRef, useState } from 'react'

interface StatCard {
  stat: string
  caption: string
  icon: React.ReactNode
  watermark: React.ReactNode
}

const cards: StatCard[] = [
  {
    stat: '62.9%',
    caption: 'of UST facilities nationwide fail inspection',
    icon: (
      <svg className="h-6 w-6 text-accent" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="9" y1="6" x2="15" y2="6" />
        <line x1="9" y1="10" x2="15" y2="10" />
        <line x1="9" y1="14" x2="12" y2="14" />
        <line x1="14" y1="16" x2="18" y2="12" />
        <line x1="18" y1="16" x2="14" y2="12" />
      </svg>
    ),
    watermark: (
      <svg className="absolute bottom-1 right-1 h-20 w-20 text-accent/[0.06]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="9" y1="6" x2="15" y2="6" />
        <line x1="9" y1="10" x2="15" y2="10" />
        <line x1="9" y1="14" x2="12" y2="14" />
        <line x1="14" y1="16" x2="18" y2="12" />
        <line x1="18" y1="16" x2="14" y2="12" />
      </svg>
    ),
  },
  {
    stat: '55%',
    caption: 'of SPCC-regulated AST facilities found noncompliant by the EPA',
    icon: (
      <svg className="h-6 w-6 text-accent" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="6" width="18" height="14" rx="2" />
        <path d="M3 13h18" />
        <path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2" />
        <line x1="10" y1="16" x2="14" y2="20" />
        <line x1="14" y1="16" x2="10" y2="20" />
      </svg>
    ),
    watermark: (
      <svg className="absolute bottom-1 right-1 h-20 w-20 text-accent/[0.06]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="6" width="18" height="14" rx="2" />
        <path d="M3 13h18" />
        <path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2" />
        <line x1="10" y1="16" x2="14" y2="20" />
        <line x1="14" y1="16" x2="10" y2="20" />
      </svg>
    ),
  },
  {
    stat: '$37,500',
    caption: 'max EPA penalty per day for UST noncompliance',
    icon: (
      <svg className="h-6 w-6 text-accent" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="6" x2="12" y2="18" />
        <path d="M9 9.5C9 8.12 10.34 7 12 7s3 1.12 3 2.5c0 2.5-3 2-3 4.5" />
        <path d="M9 14.5C9 15.88 10.34 17 12 17s3-1.12 3-2.5" />
      </svg>
    ),
    watermark: (
      <svg className="absolute bottom-1 right-1 h-20 w-20 text-accent/[0.06]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="6" x2="12" y2="18" />
        <path d="M9 9.5C9 8.12 10.34 7 12 7s3 1.12 3 2.5c0 2.5-3 2-3 4.5" />
        <path d="M9 14.5C9 15.88 10.34 17 12 17s3-1.12 3-2.5" />
      </svg>
    ),
  },
  {
    stat: '$59,114',
    caption: 'max SPCC penalty per day per AST violation',
    icon: (
      <svg className="h-6 w-6 text-accent" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 9v4" />
        <path d="M10.363 3.591l-8.106 13.534A1.914 1.914 0 004.157 20h15.686a1.914 1.914 0 001.9-2.875L13.637 3.59a1.914 1.914 0 00-3.274 0z" />
        <circle cx="12" cy="16" r="0.5" fill="currentColor" />
      </svg>
    ),
    watermark: (
      <svg className="absolute bottom-1 right-1 h-20 w-20 text-accent/[0.06]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 9v4" />
        <path d="M10.363 3.591l-8.106 13.534A1.914 1.914 0 004.157 20h15.686a1.914 1.914 0 001.9-2.875L13.637 3.59a1.914 1.914 0 00-3.274 0z" />
        <circle cx="12" cy="16" r="0.5" fill="currentColor" />
      </svg>
    ),
  },
  {
    stat: '4,307',
    caption: 'new confirmed releases from USTs in FY 2025',
    icon: (
      <svg className="h-6 w-6 text-accent" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2C12 2 7 8.5 7 13a5 5 0 0010 0C17 8.5 12 2 12 2z" />
        <path d="M10 17l1-2 2 1" />
        <line x1="12" y1="9" x2="12" y2="12" />
      </svg>
    ),
    watermark: (
      <svg className="absolute bottom-1 right-1 h-20 w-20 text-accent/[0.06]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2C12 2 7 8.5 7 13a5 5 0 0010 0C17 8.5 12 2 12 2z" />
        <path d="M10 17l1-2 2 1" />
        <line x1="12" y1="9" x2="12" y2="12" />
      </svg>
    ),
  },
  {
    stat: '40%',
    caption: 'of US groundwater contamination traced to leaking USTs',
    icon: (
      <svg className="h-6 w-6 text-accent" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="20" height="5" rx="1" />
        <rect x="2" y="9" width="20" height="5" rx="0" />
        <path d="M2 14c2 0 3 2 5 2s3-2 5-2 3 2 5 2 3-2 5-2" />
        <path d="M2 18c2 0 3 2 5 2s3-2 5-2 3 2 5 2 3-2 5-2" />
      </svg>
    ),
    watermark: (
      <svg className="absolute bottom-1 right-1 h-20 w-20 text-accent/[0.06]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="20" height="5" rx="1" />
        <rect x="2" y="9" width="20" height="5" rx="0" />
        <path d="M2 14c2 0 3 2 5 2s3-2 5-2 3 2 5 2 3-2 5-2" />
        <path d="M2 18c2 0 3 2 5 2s3-2 5-2 3 2 5 2 3-2 5-2" />
      </svg>
    ),
  },
  {
    stat: '$130,000+',
    caption: 'average cleanup cost per site — over $1M if groundwater is involved',
    icon: (
      <svg className="h-6 w-6 text-accent" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L4 7v5c0 5.25 3.4 10.15 8 11 4.6-.85 8-5.75 8-11V7l-8-5z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <circle cx="12" cy="16" r="0.5" fill="currentColor" />
      </svg>
    ),
    watermark: (
      <svg className="absolute bottom-1 right-1 h-20 w-20 text-accent/[0.06]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L4 7v5c0 5.25 3.4 10.15 8 11 4.6-.85 8-5.75 8-11V7l-8-5z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <circle cx="12" cy="16" r="0.5" fill="currentColor" />
      </svg>
    ),
  },
]

const ComplianceGap = () => {
  const sectionRef = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
          observer.disconnect()
        }
      },
      { threshold: 0.15 }
    )
    if (sectionRef.current) observer.observe(sectionRef.current)
    return () => observer.disconnect()
  }, [])

  return (
    <section className="py-16 bg-gray-100" ref={sectionRef}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">The Compliance Gap</h2>
          <div className="w-24 h-1 bg-accent mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Most storage tank facilities are one inspection away from a violation. Here's what's at stake.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Row 1: 4 cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            {cards.slice(0, 4).map((card, i) => (
              <div
                key={i}
                className={`relative bg-white rounded-lg shadow-soft overflow-hidden transform transition-all duration-500 hover:-translate-y-1.5 hover:shadow-hover ${
                  visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
                }`}
                style={{ transitionDelay: visible ? `${i * 100}ms` : '0ms' }}
              >
                <div className="h-1 bg-accent"></div>
                <div className="p-4 relative">
                  {card.watermark}
                  <div className="relative">
                    <div className="mb-2">{card.icon}</div>
                    <p className="text-2xl font-bold text-primary mb-1">{card.stat}</p>
                    <p className="text-gray-600 text-xs leading-relaxed">{card.caption}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Row 2: 3 cards centered */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:max-w-[calc(75%+0.5rem)] mx-auto">
            {cards.slice(4).map((card, i) => (
              <div
                key={i + 4}
                className={`relative bg-white rounded-lg shadow-soft overflow-hidden transform transition-all duration-500 hover:-translate-y-1.5 hover:shadow-hover ${
                  visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
                }`}
                style={{ transitionDelay: visible ? `${(i + 4) * 100}ms` : '0ms' }}
              >
                <div className="h-1 bg-accent"></div>
                <div className="p-4 relative">
                  {card.watermark}
                  <div className="relative">
                    <div className="mb-2">{card.icon}</div>
                    <p className="text-2xl font-bold text-primary mb-1">{card.stat}</p>
                    <p className="text-gray-600 text-xs leading-relaxed">{card.caption}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ComplianceGap
